export enum FUIFormationType {
    NON_COLLAPSIBLE,
    ACCORDION,
    COLLAPSIBLE
}
